import React, { useState, useEffect } from "react";
import {
  Card,
  Grid,
  Text,
  useMantineTheme,
  UnstyledButton,
  HoverCard,
  Badge,
  Group,
  Button,
  Skeleton,
  Box,
} from "@mantine/core";
import { openConfirmModal } from "@mantine/modals";
import { IconPlus } from "@tabler/icons";
import { showNotification } from "@mantine/notifications";
import { apiWithInterceptor } from "../../../../api";
import PageHeading from "../../../../components/PageHeading";
import CreateUserModal from "./CreateUserModal";
import EditUserModal from "./EditUserModal";
export default function Users() {
  const theme = useMantineTheme();
  const [loading, setLoading] = useState(false);
  const [deleteFlag, setDelete] = useState(false);
  const [opened, setOpenModal] = useState(false);
  const [openEditUserModal, setOpenEditUserModal] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [users, setUsers] = useState([]);
  const user = JSON.parse(localStorage.getItem("userInfo"));

  const openDeleteModal = (id) =>
    openConfirmModal({
      title: "Delete User",
      centered: true,
      children: (
        <Text size="sm">
          Are you sure you want to delete this user? This action is destructive
          and <span style={{ color: "red", fontWeight: "bold" }}>CANNOT</span>{" "}
          be undone.
        </Text>
      ),
      labels: { confirm: "Delete User", cancel: "Cancel" },
      confirmProps: { color: "red" },

      onConfirm: () => {
        setLoading(true);
        setDelete(true);
        apiWithInterceptor
          .delete(`/user/${id}`)
          .then(function () {
            showNotification({
              title: "Seccess",
              message: "User deleted successfully",
              color: "green",
            });
            setLoading(false);
            setDelete(false);
          })
          .catch(function (error) {
            showNotification({
              title: "Something went wrong",
              message: ` ${error?.response?.data?.message}`,
              color: "red",
            });
            setDelete(false);
            setLoading(false);
          });
      },
    });

  useEffect(() => {
    setLoading(true);
    apiWithInterceptor
      .get("/user")
      .then(function (response) {
        setUsers(response.data.array);
        setLoading(false);
        setDelete(false);
      })
      .catch(function (error) {
        showNotification({
          title: "Something went wrong",
          message: ` ${error?.response?.data?.message}`,
          color: "red",
        });
      });
  }, [deleteFlag, opened]);
  const skeleton = [1, 2, 3];
  return (
    <PageHeading>
      <Box
        sx={{
          width: "100%",
          maxWidth: "1000px",
          margin: "auto",
        }}
      >
        {user?.privileges === "ADMIN" ? (
          <Grid>
            <Grid.Col xs={12}>
              <UnstyledButton
                onClick={() => {
                  setOpenModal(true);
                }}
                sx={{ marginTop: "1em", width: "100%" }}
              >
                <Card
                  shadow="sm"
                  p="lg"
                  radius="md"
                  withBorder
                  sx={{
                    height: "5em",
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    transition: ".3s",
                    "&:hover": {
                      borderColor: theme.colors.brand[5],
                      backgroundColor: `${theme.colors.brand[9]}02`,
                    },
                  }}
                >
                  <Text>Create New User</Text>
                  <IconPlus />
                </Card>
              </UnstyledButton>
            </Grid.Col>

            {loading ? (
              <>
                {skeleton.map((item, index) => {
                  return (
                    <Grid.Col
                      key={index}
                      xs={12}
                      lg={4}
                      sm={4}
                      sx={{
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Skeleton
                        id={item}
                        sx={{
                          marginLeft: "20px",
                          marginTop: "20px",
                          height: "320px",
                          width: "17em",
                        }}
                      />
                    </Grid.Col>
                  );
                })}
              </>
            ) : (
              users.map((item, index) => (
                <Grid.Col
                  xs={12}
                  lg={4}
                  sm={4}
                  key={index}
                  sx={{
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <HoverCard width={350}>
                    <Card
                      withBorder
                      //   id={item.id}
                      shadow="sm"
                      p="lg"
                      radius="md"
                      sx={{
                        height: "320px",
                        width: "250px",
                        display: "flex",
                        marginTop: "20px",
                        flexDirection: "column",
                        //justifyContent: "center",
                        alignItems: "center",
                        transition: ".3s",
                        "&:hover": {
                          borderColor: theme.colors.brand[5],
                          backgroundColor: `${theme.colors.brand[9]}02`,
                        },
                      }}
                    >
                      <Card.Section
                        withBorder
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                          width: "100%",
                        }}
                      >
                        <HoverCard.Target>
                          <Text
                            fz="xl"
                            fw={700}
                            mt={15}
                            sx={{
                              textOverflow: "ellipsis",
                              maxWidth: "200px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                            }}
                          >
                            {item.username}
                          </Text>
                        </HoverCard.Target>
                        <Text
                          fz="sm"
                          fw={500}
                          mt={15}
                          sx={{
                            textOverflow: "ellipsis",
                            maxWidth: "200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                          color="dimmed"
                        >
                          {item.email}
                        </Text>
                        <Badge
                          variant="dot"
                          mb={15}
                          mt={15}
                          color={item?.privileges === "USER" ? "red" : "yellow"}
                        >
                          {item?.privileges}
                        </Badge>
                      </Card.Section>

                      <Card.Section
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <Group
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "row",
                          }}
                          position="apart"
                          mt="md"
                          mb="xs"
                        >
                          <Button
                            onClick={() => {
                              setOpenEditUserModal(true);
                              setCurrentUser(item.id);
                            }}
                            compact
                            variant="filled"
                            sx={{ width: "150px" }}
                          >
                            Edit User
                          </Button>

                          <Button
                            compact
                            variant="filled"
                            color="red"
                            uppercase
                            sx={{ width: "150px" }}
                            onClick={() => {
                              openDeleteModal(item.id);
                            }}
                          >
                            Delete user
                          </Button>
                        </Group>
                      </Card.Section>
                    </Card>
                    <HoverCard.Dropdown sx={{ borderColor: "#edb40d" }}>
                      <Text size="lg">{item.username}</Text>
                    </HoverCard.Dropdown>
                  </HoverCard>
                </Grid.Col>
              ))
            )}
          </Grid>
        ) : (
          <h1>Not Allowed here</h1>
        )}
      </Box>
      <CreateUserModal opened={opened} setOpenModal={setOpenModal} />
      <EditUserModal
        opened={openEditUserModal}
        setOpenEditUserModal={setOpenEditUserModal}
        currentUser={currentUser}
      />
    </PageHeading>
  );
}
